import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RmaIconComponent } from '@rma/public/generic/ui/icon';
import { ProfileAvatarComponent } from '@rma/public/profiles/public/ui-profile-avatar';
import { ComparePanelAgent } from './compare-panel-agent';

@Component({
  selector: 'rma-compare-panel',
  templateUrl: './compare-panel.component.html',
  imports: [MatButtonModule, ProfileAvatarComponent, RmaIconComponent],
  host: {
    class: 'contents',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparePanelComponent {
  protected readonly canCompare = computed(() => this.agents().length > 1);

  public readonly open = input(false);
  public readonly agents = input<readonly ComparePanelAgent[]>([]);
  public readonly heading = input('');
  public readonly compareLabel = input('');
  public readonly removeLabel = input('');
  public readonly singleHint = input('');
  public readonly addedAgentCode = input<string | null>(null);

  public readonly remove = output<string>();
  public readonly compare = output<void>();
}
